var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaiIcFormpack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10C16 9.40003 16.4 9.00003 17 9.00003C17.6 9.00003 18 9.40003 18 10V15.1C18 16.7 16.8 18 15.3 18H7.70001C6.20001 18 5 16.7 5 15.1V3.90002C5 2.30002 6.20001 1.00003 7.70001 1.00003H9C9.6 1.00003 10 1.40003 10 2.00003C10 2.60003 9.6 3.00003 9 3.00003H7.70001C7.30001 3.00003 7 3.40002 7 3.90002V15.1C7 15.6 7.30001 16 7.70001 16H15.3C15.7 16 16 15.6 16 15.1V10ZM10.3 19C10.9 19 11.3 19.4 11.3 20C11.3 20.6 10.9 21 10.3 21H2.70001C1.20001 21 0 19.7 0 18.1V6.90002C0 5.30002 1.20001 4.00003 2.70001 4.00003H3C3.6 4.00003 4 4.40003 4 5.00003C4 5.60003 3.6 6.00003 3 6.00003H2.70001C2.30001 6.00003 2 6.40002 2 6.90002V18.1C2 18.6 2.30001 19 2.70001 19H10.3ZM11.8 1.10004L17.8 7.10004C18 7.30004 18 7.60002 17.8 7.80002C17.7 7.90002 17.6 7.90002 17.5 7.90002H12.9C11.8 7.90002 11 7.00003 11 6.00003V1.40002C11 1.10002 11.2 0.900024 11.5 0.900024C11.6 1.00002 11.7 1.10004 11.8 1.10004Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaiIcFormpack);
export default __webpack_public_path__ + "static/media/mai-ic-formpack.49b073cb769bbe2c5bcb849e35afb2e0.svg";
export { ForwardRef as ReactComponent };